import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-repartition-inout',
    templateUrl: './repartition-inout.component.html',
    styleUrls: ['./repartition-inout.component.scss']
})

export class RepartitionInoutComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);

    loading = false;

    /**
     * Chart repartition
     */
    options = {
        tooltip: {
            trigger: 'item',
            formatter: '{c}€ ({d}%)'
        },
        legend: {
            orient: 'vertical',
            right: '30px',
            top: '30px',
            align: 'right',
        },
        calculable: true,
    };

    data = {
        series: []
    };

    constructor(public authenticationService: AuthenticationService,
                public deviceService: DeviceDetectorService) {
    }

    ngOnInit() {
        // Mobile : légende horizontale sous le donut (même gestion que les graphs de l'onglet Ville)
        if (this.deviceService.isMobile()) {
            this.options.legend = {
                orient: 'horizontal',
                right: 'auto',
                align: 'auto',
                left: 'center',
                bottom: 0,
            } as any;
        }
        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        this.user = this.authenticationService.currentUser;
    }

    setData() {
        this.data = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: this.deviceService.isMobile() ? ['42%', '64%'] : ['60%', '90%'],
                    center: this.deviceService.isMobile() ? ['50%', '32%'] : ['30%', '50%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '20',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: [
                        {value: Math.round(this.favorite.monthly), name: 'Mensualité'},
                        {value: Math.round(this.favorite.amount_property_tax / 12), name: 'Taxe foncière'},
                        {value: Math.round(this.favorite.agence_rental / 12 + (this.favorite.agence * this.favorite.amount_rent) / 100), name: 'Gestion en agence'},
                        {value: Math.round(this.favorite.amount_copro / 12), name: 'Charges de copro'},
                        {value: Math.round(this.favorite.amount_rent_insurance * (this.favorite.amount_rent + this.favorite.amount_copro_rent) / 100), name: 'GLI'},
                        {value: Math.round(this.favorite.building_insurance / 12), name: 'Assurance PNO'},
                        {value: Math.round(this.favorite.other_bill / 12), name: 'Autres frais'},
                        {value: Math.round((this.favorite.accouting_fees + this.favorite.cfe_contribution + this.favorite.cga_contribution) / 12), name: 'Frais de comptabilité'},
                        {value: Math.round((this.favorite.cash_flow > 0) ? this.favorite.cash_flow : 0), name: 'Cash flow'},
                    ]
                }
            ]
        };
    }
}
